/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
namespace('Slzr.Theme.ConferenceShow', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  const AGENDA_VIEW_URL = "/event/@@EVENT_ID@@/user_agenda";

  const buildURL = (template, id) => template.replace(/@@EVENT_ID@@/, id);

  return $(function() {
    if (Slzr.Meta['event-kind'] !== 'conference') { return; }

    // Register for an attendance change event, to trigger an update of the conference agenda
    return Slzr.Theme.Events.on('attendanceChange', function(data) {
      const url = buildURL(AGENDA_VIEW_URL, Slzr.Meta['event-id']);
      return $.get(url).done((responseText, xhr, settings) => $('[data-conference-agenda]').replaceWith(responseText));
    });
  });
});

